import React from 'react'
import * as S from './styled'

const PinkLine = () => (
    <S.PinkLine />
)
  
export default PinkLine
